import { Component, Vue } from 'vue-property-decorator'
import CAAG1040Service from './CAAG1040Service'
import CAAG1040ViewModel from './CAAG1040ViewModel'
import { FormatConstants } from '@/common/FormatConstants'
import CAAG1050ParamModel from '../CAAG1050/CAAG1050ParamModel'
import Pagination from '@/components/pagination/Pagination.vue'
import CommonUtil from '@/common/utils/CommonUtil'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import CommonConstants from '@/common/CommonConstants'
import { fixedContentNoLogin } from '@/assets/js/main.js'

@Component({
  name: 'CAAG1040',
  components: { Pagination }
  })
export default class CAAG1040Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private PAGE_SIZE = 20
  private isHasNewsLgnBeforeLst = false
  private FormatConstants = FormatConstants
  private CommonConstants = CommonConstants
  private caag1040Service = new CAAG1040Service()
  private caag1040ViewModel: CAAG1040ViewModel = {
    newsLgnBeforeLst: [
      {
        impttDiv: null,
        postDay: '',
        titl: '',
        id: null
      }
    ],
    totalRecord: null,
    currentPage: 1,
    recordSelectedPageLst: [],
    recordFrom: 1,
    recordTo: this.PAGE_SIZE,
    totalPage: 0
  }

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContentNoLogin()
    await this.init()
    this.$root.$emit('renderTabIndexPage', '')
    this.$root.$emit('renderEvent', '')
  }

  /**
   * 初期処理
   */
  private async init() {
    const caag1040ResponeModel = await this.caag1040Service.callAPICAAA1040()

    if (CommonUtil.isNotEmpty(caag1040ResponeModel.newsLgnBeforeLst)) {
      this.caag1040ViewModel.newsLgnBeforeLst =
        caag1040ResponeModel.newsLgnBeforeLst
      this.isHasNewsLgnBeforeLst = true
    } else {
      this.caag1040ViewModel.newsLgnBeforeLst = null
    }

    this.caag1040ViewModel.totalRecord =
      caag1040ResponeModel.newsLgnBeforeLst?.length

    this.caag1040ViewModel.recordSelectedPageLst =
      caag1040ResponeModel.newsLgnBeforeLst?.slice(0, this.PAGE_SIZE)

    this.caag1040ViewModel.totalPage = Math.ceil(
      this.caag1040ViewModel.totalRecord / this.PAGE_SIZE
    )

    if (this.caag1040ViewModel.totalPage === 1) {
      this.caag1040ViewModel.recordTo = this.caag1040ViewModel.totalRecord
    }
  }

  /**
   * 「お知らせ詳細（ログイン前）」（CAAG1050）画面に遷移する。
   * @param id お知らせ番号
   */
  private gotoCAAG1050(id: number) {
    const caag1050ParamModel: CAAG1050ParamModel = {
      id: id.toString()
    }
    this.$router.push({
      name: 'caag1050',
      query: caag1050ParamModel
    })
  }

  /**
   * 「ログイン」（CAAG1010）画面に遷移する。
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }

  /**
   * ページ数リンク押下
   * @param selectedPage 選択したページ
   */
  private changePage(selectedPage: number) {
    this.caag1040ViewModel.recordSelectedPageLst =
      this.caag1040ViewModel.newsLgnBeforeLst.slice(
        (selectedPage - 1) * this.PAGE_SIZE,
        selectedPage * this.PAGE_SIZE
      )

    this.caag1040ViewModel.currentPage = selectedPage
    this.caag1040ViewModel.recordFrom =
      (this.caag1040ViewModel.currentPage - 1) * this.PAGE_SIZE + 1

    if (
      this.caag1040ViewModel.currentPage === this.caag1040ViewModel.totalPage
    ) {
      this.caag1040ViewModel.recordTo = this.caag1040ViewModel.totalRecord
    } else {
      this.caag1040ViewModel.recordTo =
        this.caag1040ViewModel.currentPage * this.PAGE_SIZE
    }
    this.$root.$emit('renderTabIndexPage', '')
    this.$root.$emit('renderEvent', '')
  }
}
